import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { provideEchartsCore } from 'ngx-echarts';

import { routes } from './app.routes';
import { AuthInterceptor } from './auth/auth.interceptor';
import { ApiHttpsFallbackInterceptor } from './auth/api-https-fallback.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    // After AuthInterceptor, so a retried request keeps its Authorization header.
    { provide: HTTP_INTERCEPTORS, useClass: ApiHttpsFallbackInterceptor, multi: true },
    provideAnimationsAsync(),
    providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.dark' } } }),
    // Keep lazy loading, but make initialization idempotent. ngx-echarts can request
    // initialization twice while its async import and a fast options update overlap.
    provideEchartsCore({
      echarts: async () => {
        const echarts = await import('echarts');
        return {
          ...echarts,
          init: (dom: HTMLElement, theme?: string | object | null, opts?: Parameters<typeof echarts.init>[2]) =>
            echarts.getInstanceByDom(dom) ?? echarts.init(dom, theme, opts),
        };
      },
    }),
  ]
};
